/**
 * Embed Loader Entry Point
 * Lightweight script for retailers to embed the viewer
 * Module 2, Section 5.4
 */

import { EmbedLoader } from './loader/EmbedLoader';

// Export for programmatic use
export { EmbedLoader };

// Export other utilities that might be useful
export { DomainValidator } from './loader/DomainValidator';
export { IframeInjector } from './loader/IframeInjector';
export type { EmbedLoaderConfig } from './loader/EmbedLoader';
export type { IframeConfig } from './loader/IframeInjector';

// Make available globally for UMD builds
if (typeof window !== 'undefined') {
  (window as any).Fashion3DEmbedLoader = EmbedLoader;
}
